import React, { lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from '../layouts/full/shared/loadable/Loadable'; 
import AuthGuard from '../guards/authGuard/AuthGuard';
import GuestGuard from '../guards/authGuard/GuestGaurd'; 
import LoadingSpinner from '../components/LoadingSpinner';
import Error from '../views/authentication/Error';
import SupplierGuard from '../guards/supplier/SupplierGuard';
 
// Import your layouts
const FullLayout = Loadable(lazy(() => import('../layouts/full/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/blank/BlankLayout')));

// Authentication pages
const Login = Loadable(lazy(() => import('../views/authentication/auth/Login')));
const ForgotPassword = Loadable(lazy(() => import('../views/authentication/auth/ForgotPassword')));
const TwoSteps = Loadable(lazy(() => import('../views/authentication/auth/TwoSteps')));


// Dashboard and other protected pages
const Dashboard = Loadable(lazy(() => import('../views/dashboard/Main')));

//Sanayi Listesi
const Industry = Loadable(lazy(() => import('../views/industry/Industry')));

//Duyuru Listesi
const Notice = Loadable(lazy(() => import('../views/notification/Notice')));

//İhbar Listesi
//const NoticeList = Loadable(lazy(() => import('../views/notice/noticeList')));

//Servis Listesi
const Service = Loadable(lazy(() => import('../views/callcenter/Service')));

//Tedarikçi Listesi
const Supplier = Loadable(lazy(() => import('../views/supplier/Supplier')));

//Call Center
const ServiceDetail = Loadable(lazy(() => import('../components/apps/callcenter/ServiceDetail')));

const Services = Loadable(lazy(() => import('../components/apps/callcenter/Service')));

//Yeni Hizmet ekleme
//const NewService = Loadable(lazy(() => import('../components/service/Service')));

//Cagri Merkezi
const CagriMerkeziEski = Loadable(lazy(() => import('../components/apps/callcenter/CagriMerkezi')));

//Servis Foemu Son
const ServiceArea = Loadable(lazy(() => import('../components/apps/service/CagriMerkezi')));

//Cagri Merkezi
const CagriMerkezi = Loadable(lazy(() => import('../components/apps/cagrimerkezi/cagrimerkezi')));

//CheckMate Process
//const CheckMateProcess = Loadable(lazy(() => import('../components/apps/cagrimerkezi/CheckMateProcess')));


//Onay
const Approve = Loadable(lazy(() => import('../views/approve/approve')));

//Tedarikçi Dosya Yükleme
const SupplierFileUpload = Loadable(lazy(() => import('../components/apps/supplierapp/SupplierFileUpload')));

//Google Map
const GoogleMap = Loadable(lazy(() => import('../components/apps/supplier/CustomerMapsInfo')));

//Tedarikçi Login İşlemleri
const SupplierLogin = Loadable(lazy(() => import('../components/apps/supplierapp/Login')));

//Tedarikçi sayfaları için import
const SupplierMain = Loadable(lazy(() => import('../components/apps/supplierapp/Main')));

//Kara Liste İşlemleri  
const BlackList = Loadable(lazy(() => import('../components/apps/bkacklist/BlackList')));

//Supplier Initial Check
const SupplierInitialCheck = Loadable(lazy(() => import('../components/apps/supplierapp/SupplierInitialCheck')));

// Supplier Invoice Upload
const SupplierInvoiceUpload = Loadable(lazy(() => import('../components/apps/supplierapp/SupplierInvoiceUpload')));

// Find Customer
const FindCustomer = Loadable(lazy(() => import('../components/apps/supplier/FindCustomer')));

// User Profile
const UserProfile = Loadable(lazy(() => import('../views/user/UserProfile')));


// Define routes
const Router = [
  {
    path: '/',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
      <AuthGuard>
        <FullLayout />
      </AuthGuard>
    </Suspense>
    ),
    children: [
      { path: '/', element: <Navigate to="/dashboards/main" /> },  
      { path: '/dashboards/main', exact: true, element: <Dashboard /> }, 
      { path: '/apps/industry', exact: true, element: <Industry /> }, 
      { path: '/apps/notice', exact: true, element: <Notice /> }, 
      { path: '/apps/notice-list', exact: true, element: <Service /> }, 
      { path: '/apps/supplier', exact: true, element: <Supplier /> },   
      { path: '/apps/approve', exact: true, element: <Approve /> },
      { path: '/apps/blacklist', exact: true, element: <BlackList /> },
      { path: '/user-profile', exact: true, element: <UserProfile /> }, 
      // { path: '/apps/service-detail/:contractNo', exact: true, element: <NewService /> },
      // { path: '/apps/service/:contractNo', exact: true, element: <ServiceDetail /> },

      { path: '/apps/service/:contractNo', exact: true, element: <CagriMerkezi /> },
    ], 
  },
  {
    path: '/auth',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <GuestGuard>
          <BlankLayout />
        </GuestGuard>
      </Suspense>
    ),
    children: [
      { path: '/auth/login', element: <Login /> },   
      { path: '/auth/forgot-password', element: <ForgotPassword /> }, 
      { path: '/auth/two-steps', element: <TwoSteps /> },
      { path: '/auth/404', element: <Error /> },
      // // { path: '/auth/two-steps2', element: <TwoSteps2 /> },
      // { path: '/auth/maintenance', element: <Maintenance /> },  

    ],
  },
  { 
    path: '/',
    element: <BlankLayout />,
    children: [
      { path: '404', element: <Error /> },
      { path: '*', element: <Navigate to="/auth/404" /> },    
      { path: '/--TedarikciDosyaYukleme/:idCcnNotificationService/:dsContractNo', exact: true, element: <SupplierFileUpload /> },
      { path: '/konumtalebi/:idNotification/:dsContractNo', exact: true, element: <GoogleMap /> }, // müşteriden istenecek konum talebi ekranı 
      { path: '/yonlendir/:idNotification', exact: true, element: <FindCustomer /> }, // müşteriden istenecek hizmet durumu ekranı 
      {
        path: '/TedarikciDosyaYukleme/:idCcnNotificationService/:dsContractNo',
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <SupplierInitialCheck />
          </Suspense>
        )
      },
      // {
      //   path: '/--TedarikciDosyaYukleme/:idCcnNotificationService/:dsContractNo',
      //   element: (
      //     <Suspense fallback={<LoadingSpinner />}>
      //       <SupplierGuard>
      //         <SupplierFileUpload />
      //       </SupplierGuard>
      //     </Suspense>
      //   )
      // },
      { 
        path: '/SupplierLogin/:phoneNumber', 
        exact: true, 
        element: <SupplierLogin /> 
      },
      { 
        path: '/Supplier/Main', 
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <SupplierGuard>
              <SupplierMain />
            </SupplierGuard>
          </Suspense>
        ) 
      },
    ],
  },
  {
    path: '/supplier',
    element: <BlankLayout />,
    children: [
      // Ana giriş kontrolü
      {
        path: 'check/:idCcnNotificationService/:dsContractNo',
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <SupplierInitialCheck />
          </Suspense>
        )
      },
      // Korumalı sayfalar
      {
        path: 'main',
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <SupplierGuard>
              <SupplierMain />
            </SupplierGuard>
          </Suspense>
        )
      },
      {
        path: 'TedarikciDosyaYukleme/:idCcnNotificationService/:dsContractNo',
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <SupplierGuard>
              <SupplierFileUpload />
            </SupplierGuard>
          </Suspense>
        )
      },
      {
        path: 'fatura-yukleme',
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <SupplierGuard>
              <SupplierInvoiceUpload />
            </SupplierGuard>
          </Suspense>
        )
      }
    ]
  }
];

export default Router;
